"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./UserItem.scss");
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _Avatar = _interopRequireDefault(require("./Avatar"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UserItem = function UserItem(_ref) {
  var name = _ref.name,
    avatar = _ref.avatar,
    helper = _ref.helper,
    role = _ref.role;
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    direction: "row",
    customClass: "UserItem",
    align: "center",
    gap: 200
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    size: "medium",
    avatar: avatar,
    altText: name,
    role: role
  }), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    direction: "column",
    customClass: "UserInfo"
  }, /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    size: "medium",
    weight: "bold"
  }, name), /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    size: "small"
  }, helper)));
};
var _default = exports["default"] = UserItem;